import { Component, Input, OnInit } from '@angular/core';
import { ConfigWebsite } from '../../../projects/shared-lib/src/lib/models/config-website';
import { BannersService } from '../banners.service';
import { lastValueFrom } from 'rxjs';
import { ImageSizeEnum } from '../../../projects/shared-lib/src/lib/models/image-size-enum';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ImageDetail } from '../../../projects/shared-lib/src/lib/models/image-detail';
import { Router, RouterOutlet } from '@angular/router';
import { ClientService } from '../../modules/client/client.service';
import { AnalyticsService } from '../../modules/shared/services/analytics.service';
import { Sta } from '../../../projects/shared-lib/src/lib/models/address';
import { constSystem } from '../../../projects/shared-lib/src/lib/utils/const-system';
import { HelpsService } from '../../../projects/shared-lib/src/lib/utils/helps.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDrawerContainer, MatDrawer, MatDrawerContent } from '@angular/material/sidenav';
import { NgClass } from '@angular/common';
import { MatDivider } from '@angular/material/divider';
import { LangsComponent } from '../../modules/shared/component/langs/langs.component';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { AppCartComponent } from '../../modules/cart/component/app-cart/app-cart.component';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { FilterPagesEventsComponent } from '../filter-pages-events/filter-pages-events.component';
import { ButtonFloatingOrderComponent } from '../../modules/button-floating-order/button-floating-order/button-floating-order.component';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormErrorMessageComponent } from '../../modules/shared/component/form/form-error-message/form-error-message.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'tw-tkp-template',
    templateUrl: './tkp-template.component.html',
    styleUrls: ['./tkp-template.component.css'],
    imports: [MatDrawerContainer, MatDrawer, NgClass, MatDivider, LangsComponent, MatDrawerContent, MatToolbar, MatToolbarRow, AppCartComponent, MatIconButton, MatMenuTrigger, MatIcon, MatMenu, MatButton, FilterPagesEventsComponent, RouterOutlet, ButtonFloatingOrderComponent, FormsModule, MatFormField, MatLabel, MatInput, MatError, FormErrorMessageComponent, MatSelect, MatOption, TranslatePipe]
})
export class TkpTemplateComponent implements OnInit {
    @Input() loggedIn;
    @Input() configWeb: ConfigWebsite;
    @Input() showCart: any;

    provinces = <Sta[]>constSystem.world.provinces;
    provinceSelected: Sta;
    menus = [
        {
            url: '',
            translate: 'title.sport',
            auth: false,
            public: true

        },
        {
            url: '',
            translate: 'title.music',
            auth: false,
            public: true

        },
        {
            url: '',
            translate: 'title.comedy',
            auth: false,
            public: true

        },
        {
            url: '',
            translate: 'title.festival',
            auth: false,
            public: true

        },
        {
            url: '',
            translate: 'title.art',
            auth: false,
            public: true

        },
        {
            url: '',
            translate: 'title.exhibition',
            auth: false,
            public: true

        },
        {
            url: '/locations',
            translate: 'title.venue',
            auth: false,
            public: true

        }
        ,
        {
            url: '/client/login',
            translate: 'title.login',
            auth: false,
            reverse: true
        }
        ,
        {
            url: '/client/signup',
            translate: 'title.signUp',
            auth: false,
            reverse: true
        }
        ,
        {
            url: '/static/faq',
            translate: 'title.faq',
            auth: false,
            public: true,
            reverse: true
        }
        ,
        {
            url: '/static/contact',
            translate: 'title.contact',
            auth: false,
            public: true,
            reverse: true
        }
        ,
        {
            url: 'https://ticketprocanada.ca/fr/index.html',
            translate: 'title.solution',
            auth: false,
            public: true,
            reverse: true
        }
        ,
        {
            url: '/client/client-forgot-password',
            translate: 'client.forgotPassword',
            auth: false,
            reverse: true
        }
        ,
        // {
        //     url: 'profile',
        //     translate: 'title.profile',
        //     auth: true,
        //     reverse: true
        // }
        // ,
        // {
        //     url: 'invoices',
        //     translate: 'title.invoices',
        //     auth: true,
        //     reverse: true
        // }
        // ,
        // {
        //     url: 'tickets',
        //     translate: 'title.myTickets',
        //     auth: true,
        //     reverse: true
        // }
        // ,
        // {
        //     url: 'flex-pass-list',
        //     translate: 'title.flex-pass',
        //     auth: true,
        //     reverse: true
        // },
        // {
        //     url: 'change-password',
        //     translate: 'title.changePassword',
        //     auth: true,
        //     reverse: true
        // },

        {
            url: 'logout',
            translate: 'title.logout',
            auth: true,
            reverse: true
        }
        // ,
        // {
        //     url: '',
        //     translate: 'title.lang',
        //     auth: false,
        //     public: true,
        //     reverse: true
        // }
    ];
    menusAccount = [
        {
            url: '/client/login',
            translate: 'title.login',
            auth: false,
            reverse: true
        }
        ,
        {
            url: '/client/signup',
            translate: 'title.signUp',
            auth: false,
            reverse: true
        },
        {
            url: '/client/client-forgot-password',
            translate: 'client.forgotPassword',
            auth: false,
            reverse: true
        }
        ,
        {
            url: '/client/auth/profile',
            translate: 'title.profile',
            auth: true,
            reverse: true
        }
        ,
        {
            url: '/client/auth/invoices',
            translate: 'title.invoices',
            auth: true,
            reverse: true
        }
        ,
        {
            url: '/client/auth/tickets',
            translate: 'title.myTickets',
            auth: true,
            reverse: true
        }
        ,
        {
            url: '/client/auth/flex-pass-list',
            translate: 'title.flex-pass',
            auth: true,
            reverse: true
        },
        {
            url: '/client/auth/change-password',
            translate: 'title.changePassword',
            auth: true,
            reverse: true
        },

        {
            url: 'logout',
            translate: 'title.logout',
            auth: true,
            reverse: true
        }
    ];
    menusFilter;
    menusAccountFilter;
    listImages1920 = [];
    listImages728 = [];
    carousels = [];


    constructor(public bannersService: BannersService, public translate: TranslateService,
                private router: Router, private clientService: ClientService,
                private analyticsService: AnalyticsService,
                public helpsService: HelpsService,
                public breakpointObserver: BreakpointObserver
    ) {
    }

    async ngOnInit() {
        this.clientService.subLogin.asObservable().subscribe(logging => {
            this.loggedIn = logging;
            if (this.loggedIn) {
                this.menusFilter = this.menus.filter(value => value.auth || value.public);
                this.menusAccountFilter = this.menusAccount.filter(value => value.auth);
            } else {
                this.menusFilter = this.menus.filter(value => !value.auth || value.public);
                this.menusAccountFilter = this.menusAccount.filter(value => !value.auth);
            }
        });

        if (this.loggedIn) {
            this.menusFilter = this.menus.filter(value => value.auth || value.public);
            this.menusAccountFilter = this.menusAccount.filter(value => value.auth);
        } else {
            this.menusFilter = this.menus.filter(value => !value.auth || value.public);
            this.menusAccountFilter = this.menusAccount.filter(value => !value.auth);
        }
        this.breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                console.log(result);
            }
        });
    }


    goClientRoute(login: string) {

    }

    goToRoute(val: string) {
        console.log(this.translate.currentLang + val);
        if (val.search('http') !== -1) {
            window.open(val, '_blank').focus();
            return;
        }

        if (val === 'logout') {
            this.analyticsService.trackLogout();
            this.clientService.logoutClient(this.configWeb.accountCode).subscribe(value => {
                //this.router.navigate([this.translate.currentLang + '/client/login']);

                if (this.router.url.search('/checkout/mode') !== -1) {
                    /*** dans la page checkout/mode il faut le rediriger  **/

                    return;
                }
                this.goToRoute('/client/login');
                this.loggedIn = false;
            });
            return;
        }
        if (this.translate && this.translate.currentLang) {
            this.router.navigate([this.translate.currentLang + val]);
        } else {
            this.router.navigate([val]);
        }
    }

    selectProvince(st: Sta) {
        this.provinceSelected = st;
    }
}
